<template>
  <div
    v-if="isPicView || isProjectRepresentative"
    id="project-documents-add-doc-type"
    class="project-documents-add-doc-type float-right"
  >
    <button
      id="project-documents-documents-add"
      type="button"
      class="btn btn--orange"
      :disabled="isProjectCompleted"
      @click="openModal"
    >
      {{ $t('project.docs.addFolder') }}
    </button>
    <Modal
      ref="docTypeModal"
      :className="'add-doc-type-modal'"
      :modalId="`addDocTypeModal_${+new Date()}`"
    >
      <div id="confirm-create-container">
        <p class="confirm-header">
          {{ $t('project.docs.addFolders') }}
        </p>
        <table>
          <thead>
            <tr>
              <th colspan="2">
                {{ $t('project.docs.projectFolder') }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(doctype, index) in docTypes"
              :key="index"
            >
              <td>{{ doctype.folderType }}</td>
              <td>
                <div class="float-right">
                  <i
                    v-if="doctype.amount>0"
                    class="fa fa-minus cursor"
                    aria-hidden="true"
                    @click="updateDocTypeAmount(index, false)"
                  />
                  <i
                    v-else
                    class="fa fa-minus cursor disabled-minus"
                    aria-hidden="true"
                  />
                  <input
                    v-model="doctype.amount"
                    type="text"
                    class="doctype-amount"
                    disabled
                  >
                  <i
                    class="fa fa-plus cursor"
                    aria-hidden="true"
                    @click="updateDocTypeAmount(index, add)"
                  />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row align-right nav_btn">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeModal()"
        >
          {{ $t('action.cancel') }}
        </button>
        <button
          type="button"
          class="btn btn--orange"
          :disabled="disableBtn"
          @click="add()"
        >
          {{ $t('action.add') }}
        </button>
      </div>
    </Modal>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import lodash from 'lodash'
import Modal from '@/controls/Modal'
import { createFolders } from '@/api/folders/request'
import { projectStatus } from '@/utils/locale'
import { DocTypes } from '@/utils/consts'
import { mapGetters, mapActions } from 'vuex'
import { aclHelper } from '@/utils/aclHelper'
import { useIsProjectRepresentative } from '@/pages/projects/projectInfo'

export default {
  name: 'AddDocType',
  components: {
    Modal,
  },
  setup () {
    let returnData = {}
    const isProjectRepresentative = useIsProjectRepresentative()
    returnData = {
      ...returnData,
      isProjectRepresentative,
    }
    return returnData
  },
  data () {
    return {
      docTypes: [
        { folderType: DocTypes.layoutDrawings, amount: 0 },
        { folderType: DocTypes.diagramDrawings, amount: 0 },
        { folderType: DocTypes.otherDrawings, amount: 0 },
        { folderType: DocTypes.certificates, amount: 0 },
        { folderType: DocTypes.forms, amount: 0 },
        { folderType: DocTypes.manual, amount: 0 },
        { folderType: DocTypes.testReport, amount: 0 },
        { folderType: DocTypes.photoRecord, amount: 0 },
        { folderType: DocTypes.warrantyDocument, amount: 0 },
        { folderType: DocTypes.deliveryNote, amount: 0 },
        { folderType: DocTypes.others, amount: 0 },
      ],
      disableBtn: true,
    }
  },
  computed: {
    ...mapGetters('projects', [
      'currentProject',
    ]),
    isPicView () {
      return aclHelper.isProjectPic()
    },
    isProjectCompleted () {
      return this.currentProject.status === projectStatus.COMPLETED
    },
  },
  mounted () {
  },
  methods: {
    initData () {
      this.docTypes.forEach(item => {
        item.amount = 0
      })
      this.disableBtn = true
    },
    openModal () {
      this.initData()
      this.$refs.docTypeModal.open()
    },
    closeModal () {
      this.$refs.docTypeModal.close()
    },
    updateDocTypeAmount (index, isAdded = true) {
      const docType = this.docTypes[index]
      if (isAdded) {
        docType.amount += 1
      } else {
        docType.amount -= 1
      }
      const foldersToAdd = lodash.filter(this.docTypes, folder => folder.amount > 0)
      this.disableBtn = foldersToAdd.length < 1
    },
    async add () {
      const projectId = this.currentProject.id
      const request = {
        projectId,
        folders: lodash.filter(this.docTypes, folder => folder.amount > 0),
      }
      await createFolders(request)
      await this.loadProject(projectId)
      EventBus.$emit('modules.projects.documents.folderUpdated')
      this.closeModal()
    },
    ...mapActions('projects', ['loadProject']),
  },
}
</script>

<style lang="scss">
.add-doc-type-modal {
  padding-left: 0;
  padding-right: 0;

  .close-button {
    display: none;
  }

  .doc-type {
    margin-top: 0.5rem;
  }

  .cursor {
    cursor: pointer;
  }

  .action-buttons {
    margin-top: 60px;
  }

  .disabled-minus {
    color: #e0e0e0;
  }

  table {
    border-collapse: collapse;
    thead {
      color: #0C3A58;
    }
  }

  tr {
    border-top: 1px solid #e0e0e0;

    th, td:first-child {
      padding-left: 1.5rem;
    }
    td:last-child {
      padding-right: 1.5rem;
    }
  }

  tbody tr:last-child {
    border-bottom: 1px solid #e0e0e0;
  }

  .doctype-amount {
    width: 30px;
    height: 30px;
    padding: 0;
    margin-bottom: 0;
    text-align: center;
    display: inline-block;
  }
}
</style>

<style lang="scss" scoped>
@import '~styles/popup';

#project-documents-documents-add {
  margin: 0;
}
</style>
